// Shareable lesson state lives in the hash query, e.g.
// #/demos/earth-seasons?day=355 — teachers can copy the URL to reopen the
// exact same setup. The `?fallback=1` switch stays in location.search and is
// preserved untouched by writes here.

export function readHashParams(): URLSearchParams {
  if (typeof window === "undefined") {
    return new URLSearchParams();
  }
  const hash = window.location.hash;
  const queryIndex = hash.indexOf("?");
  return new URLSearchParams(
    queryIndex === -1 ? "" : hash.slice(queryIndex + 1),
  );
}

export function readHashNumber(name: string): number | null {
  const raw = readHashParams().get(name);
  if (raw === null) {
    return null;
  }
  const value = Number(raw);
  return Number.isFinite(value) ? value : null;
}

export function writeHashParams(params: Record<string, string>): void {
  if (typeof window === "undefined") {
    return;
  }
  const hash = window.location.hash || "#/";
  const queryIndex = hash.indexOf("?");
  const path = queryIndex === -1 ? hash : hash.slice(0, queryIndex);
  const nextHash = `${path}?${new URLSearchParams(params).toString()}`;
  if (window.location.hash === nextHash) {
    return;
  }
  // replaceState keeps the back button clean and does not fire hashchange,
  // so the router does not remount the demo while the teacher works.
  window.history.replaceState(
    null,
    "",
    `${window.location.pathname}${window.location.search}${nextHash}`,
  );
}
